module.exports = __webpack_public_path__ + "static/media/G1-17-Armas-Secretas-da-Ilha-de-Náxos-cod37.3f7bc770.png";